export const LOAD_TENDERS_CHANGE_TRACKING = {
  newTendersAccept: {
    source: 'load_tenders.new_tenders.accept',
    id: 26001,
  },
  newTendersReject: {
    source: 'load_tenders.new_tenders.reject',
    id: 26002,
  },
  newTendersLink: {
    source: 'load_tenders.new_tenders.link',
    id: 26003,
  },
  acceptedUnlink: {
    source: 'load_tenders.accepted.unlink',
    id: 26004,
  },
  rejectedAccept: {
    source: 'load_tenders.rejected.accept',
    id: 26005,
  },
  rejectedLink: {
    source: 'load_tenders.rejected.link',
    id: 26006,
  },
  cancelledAccept: {
    source: 'load_tenders.cancelled.accept',
    id: 26007,
  },
  cancelledLink: {
    source: 'load_tenders.cancelled.link',
    id: 26008,
  },
  expiredAccept: {
    source: 'load_tenders.expired.accept',
    id: 26009,
  },
  expiredLink: {
    source: 'load_tenders.expired.link',
    id: 26010,
  },
} as const;
